import TenantOptionHelper from 'helper/TenantOptionHelper'
import AuthHelper from 'helper/AuthHelper'
import LoginApi from 'api/LoginApi'
import { path } from 'd3'

export default {
    _toLoginPage(to, next) {
        if(to.path.startsWith('/login')) {
            next()
        } else {
            next({name: 'login'})
        }
    },
    _toRegistrationQuizLinkPage(to, next){
        let param = to.params
        if(to.path.startsWith('/input-participant')) {
            next()
        } else {
            // next({name: 'Input Participant', params: { quizIdBase64: param.quizIdBase64, quizNameBase64: param.quizNameBase64}})
            next({path:'/input-participant/' + param.quizIdBase64 + '/' + param.quizNameBase64 })
        }
    },
    _processForLogin(to, from, next, context) {
        if(to.path.startsWith('/assessment-quiz')){
            if (!AuthHelper.hasLogin(context)){
                this._toRegistrationQuizLinkPage(to, next)
                return
            }
            else{
                next()
                return
            }
        }
        else if (to.path.startsWith('/input-participant')){
            next()
            return
        }
        else{
            if (!AuthHelper.hasLogin(context)) {
                this._toLoginPage(to, next)
                return
            }
        } 

        AuthHelper.setUserContextIfNotExists(context).then(() => {
            if(to.path.startsWith('/login')) {
                next(AuthHelper.getUrlAfterLogin())
            } else {
                next()
            }
        })
    },
    beforeEach(to, from, next) {
        let context = jng.context.getContext()
        if (context) {
            this._processForLogin(to, from, next, context)
            return
        }
        LoginApi.checkIfAlreadyLogin().then(response => {
            context = jng.context.createNewContext()
            TenantOptionHelper.set(context, response)
            AuthHelper.setForCheckToken(context, response)
            this._processForLogin(to, from, next, context)
        })
        
    }
}